'use client';

import dynamic from 'next/dynamic';

export const HitCounterDemo = dynamic(
  () => import('./HitCounterDemo')
);
